import { UserStatusEnum } from '@aorg/models/enums/access/UserStatusEnum';
import { selectSessionUser, useAppSelector } from '@aorg/store';
import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import { Cog6ToothIcon } from '@heroicons/react/24/solid';
import classNames from 'classnames';
import { useMemo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { usePageTour } from '../hooks/usePageTour';
import { useScrollViewContext } from './AorgScrollView';
import QuestionIcon from './icons/QuestionIcon';
import LogoHome from './layout/LogoHome';

// Header of the layout without the Home / Resources / Network / Profile menu
// (AuthHeader keeps the menu version): the home is the only root, Profile
// opens from the gear icon and every other page gets a back arrow.
function AppHeader() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const scroll = useScrollViewContext();
  const user = useAppSelector(selectSessionUser);
  const pageTour = usePageTour();
  const isHome = pathname === '/';
  const isPending = user?.status === UserStatusEnum.Pending;

  useMemo(() => {
    if (scroll?.scrollY !== null) scroll?.scrollToTop();
  }, [pathname]);

  return (
    <div
      className={classNames(
        scroll?.scrollY && scroll?.scrollY > 20 ? 'bg-black' : 'bg-black/50',
        'flex h-auto w-full fixed z-30 items-center justify-between py-3 px-6 lg:px-12'
      )}
    >
      <div className="flex flex-row items-center gap-3">
        {!isHome && (
          <button
            type="button"
            aria-label="Back"
            onClick={() =>
              window.history.length > 1 ? navigate(-1) : navigate('/')
            }
          >
            <ArrowLeftIcon className="h-8 w-8 text-primary" />
          </button>
        )}
        <LogoHome className="h-5 md:h-6 lg:h-7 w-auto" />
      </div>

      {!isPending && (
        <div className="flex flex-row items-center gap-2">
          {pageTour.tours.length > 0 && (
            <button
              type="button"
              aria-label="Welcome tour"
              className="p-2 rounded-sm hover:bg-secondary-500/20"
              onClick={pageTour.showTour}
            >
              <QuestionIcon size={28} color="white" />
            </button>
          )}

          {!pathname.startsWith('/profile') && (
            <Link
              to="/profile"
              aria-label="Settings"
              className="p-2 rounded-sm hover:bg-secondary-500/20"
            >
              <Cog6ToothIcon className="h-8 w-8 text-white" />
            </Link>
          )}
        </div>
      )}
    </div>
  );
}

export default AppHeader;
